import { NgModule } from '@angular/core';
import { ActivityReportComponent } from './pages';
import { CommonModule } from '@angular/common';
import { services } from './shared/services';
import { ActivityReportDisplayComponent } from './components/activity-report-display';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InternalSharedModule } from '../shared';
import { SharedModule } from '../../shared';
import { EffectsModule } from '@ngrx/effects';
import { ActivityEffects } from './activity-store/activity.effects';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DxPaginationModule } from 'devextreme-angular/ui/pagination';
import { DxDateRangeBoxModule } from 'devextreme-angular';

const PROVIDERS = [
  ...services,
];

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ActivityEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,
    ReactiveFormsModule,
    SharedModule,
    DxPaginationModule,
    DxDateRangeBoxModule
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [
    /* Pages */
    ActivityReportComponent,

    /* Components */
    ActivityReportDisplayComponent,
  ],
  exports: [
    ActivityReportComponent,
  ]
})
export class ActivityModule {
}
